import {
  ArrayItemsRequiredValidation,
  BedragValidation,
  DateValidation,
  HasFileMaxSizeValidation,
  HasMaxFilesUploadValidation,
  HasMaxLengthValidation,
  HasSpecificLengthValidation,
  IbanValidation,
  IntegerValidation,
  IsRequiredValidation,
  PostcodeValidation
} from "@generation/form";
import { translate } from "../locales/src/translate";
import { DateNotInFutureValidation } from "./date-not-in-future";
import { DateNotInPastValidation } from "./date-not-in-past";
import { HasMinimalAmountValidation } from "./HasMinimalAmountValidation";
import { IArrayValidation } from "@generation/core";

export const IsRequiredValidationFactory = () => new IsRequiredValidation(false);
export const IsIbanValidationFactory = () =>
  new IbanValidation(
    false,
    (label?: string) =>
      `U heeft het invulveld '${label}' niet juist ingevuld, voorbeeld: NL01ABCD0123456789 (vervangen door uw eigen IBAN).`
  );
export const HasMaxLengthValidationFactory = (maxLength?: number) =>
  new HasMaxLengthValidation(
    maxLength || 50,
    (label?: string) =>
      `U heeft het invulveld '${label}' niet juist ingevuld, u mag maximaal ${
        maxLength || 50
      } karakters invullen.`,
    true
  );
export const MinimalAmountValidationFactory = (minimalAmount: number, errorText?: string) =>
  new HasMinimalAmountValidation(
    minimalAmount,
    () =>
      errorText ??
      "Het minimumbedrag voor een betalingsregeling is € 10 per maand. Kunt u dit niet missen? Neem dan telefonisch contact met ons op.",
    true
  );

export const IsPostcodeValidationFactory = () =>
  new PostcodeValidation(
    false,
    (label?: string) =>
      `U heeft het invulveld '${label}' niet juist ingevuld, voorbeeld: 1234 AB (vervangen door uw eigen postcode).`
  );
export const IsBedragValidationFactory = () =>
  new BedragValidation(
    false,
    (label?: string) =>
      `U heeft het invulveld '${label}' niet juist ingevuld. voorbeeld: 2500 of 2.500,00 (vervangen door uw inkomen).`
  );

export const HasFileMaxSizeValidationFactory = () =>
  new HasFileMaxSizeValidation(
    5,
    (label?: string) =>
      `U heeft in het invulveld '${label}' meer dan de maximaal toegestane bestandsgrootte geüpload, bijlagen mogen maximaal 5MB zijn.`,
    (fileLabel?: string) =>
      `'${fileLabel}' is groter dan de maximaal toegestane bestandsgrootte, bijlagen mogen maximaal 5MB zijn.`
  );

export const HasMaxFilesUploadValidationFactory = () =>
  new HasMaxFilesUploadValidation(
    5,
    (label?: string) =>
      `U heeft in het invulveld '${label}' meer dan het toegestane aantal bijlagen geüpload, u mag maximaal 5 bijlagen uploaden.`
  );

export const DateValidationFactory = (isRequired = true) => new DateValidation(isRequired);

export const HasSpecificLengthValidationFactory = (specificAmount: number) =>
  new HasSpecificLengthValidation(specificAmount, undefined, true);

export const IsIntegerValidationFactory = () => new IntegerValidation(false);

export const DateNotInFutureValidationFactory = (isRequired = true) =>
  new DateNotInFutureValidation(isRequired, (label?: string) =>
    translate("Generation_Form_{label}IsGeenGeldigeDatumOfInDeToekomst", { label: label || "" })
  );

export const DateNotInPastValidationFactory = (isRequired = true) =>
  new DateNotInPastValidation(isRequired, (label?: string) =>
    translate("DateNotInPastValidationFactoryText", { label: label || "" })
  );

export const ArrayItemsRequiredValidationFactory = (label: string, dependsOn = true) => {
  class CustomArrayItemsRequiredValidation extends ArrayItemsRequiredValidation implements IArrayValidation {
    message = (): string => translate("Generation_Form_MinimaalEen{label}IsVerplicht", { label });
  }

  return new CustomArrayItemsRequiredValidation(dependsOn);
};
